import { DBOperationEnum, FirmSecondaryApiTypeRecord } from '@tassat/fred-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import { getFirmApiTypes } from './common';

const getFirmId = (_state: AdminState | ClientState, firmId: string) => firmId;
const getIncludeDeleted = (_state: AdminState | ClientState, _firmId: string, includeDeleted: boolean) => includeDeleted;

export const getActiveApiTypes = createSelector(
    [getFirmApiTypes],
    (firmApiTypes): {
        [firmId: string]: FirmSecondaryApiTypeRecord[];
    } => {
        return Object.keys(firmApiTypes)
            .reduce((acc, firmId) => {
                const firmApiTypesArray = Object.values(firmApiTypes[firmId]);
                const activefirmApiTypes = firmApiTypesArray
                    .filter((firmApi) => firmApi.DbOperation !== DBOperationEnum.DELETE_OP.charCodeAt(0));

                acc[firmId] = activefirmApiTypes;

                return acc;
            }, {});
    }
);

export const getApiTypesByFirmId = createSelector(
    [ getFirmApiTypes, getFirmId, getIncludeDeleted ],
    (firmApiTypes, firmId, includeDeleted): Array<FirmSecondaryApiTypeRecord> => {
        if (firmApiTypes[firmId]) {
            const firmApiTypesArray = Object.values(firmApiTypes[firmId]);
            if (!includeDeleted) {
                return firmApiTypesArray.filter((api) => api.DbOperation !== DBOperationEnum.DELETE_OP.charCodeAt(0));
            }

            return firmApiTypesArray;
        }

        return [];
    }
);

export const getAllFirmApiTypesArray = createSelector(
    [ getFirmApiTypes, getIncludeDeleted ],
    (firmApiTypes, includeDeleted): Array<FirmSecondaryApiTypeRecord> => {
        const result: Array<FirmSecondaryApiTypeRecord> = [];
        Object.keys(firmApiTypes)
            .forEach((firmId) => {
                result.push(...Object.values(firmApiTypes[firmId]));
            });

        if (!includeDeleted) {
            return result.filter((api) => api.DbOperation !== DBOperationEnum.DELETE_OP.charCodeAt(0));
        }

        return result;
    }
);